<template>
    <div id="batchUpdatEditForm">
                <!--输入框-->
        <div style="width: 100%;">

            <a-date-picker
                    size="small"
                    v-if="fieldType == 'Datetime' || fieldType == 'Date'"
                    style="width: 80%"
                    allowClear
                    showTime
                    :format="fieldType == 'Datetime' ? ' YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'"
                    @change="dateTimeChange"
                    v-decorator="[
                                                        fieldValue,
                                                        {
                                                          initialValue:fieldValue == undefined ? fieldType == 'Date' ? moment(new Date(), 'YYYY-MM-DD HH:mm:ss') : null : moment(fieldValue, 'YYYY-MM-DD HH:mm:ss'),
                                                          rules: [
                                                          ]
                                                        }
                                                      ]">
            </a-date-picker>
            <a-input
                    v-model="fieldValue"
                    ref="fieldTypeStringRefs"
                    size="small"
                    v-else
                    autocomplete="off"
                    style="width: 80%"
                    v-decorator="[
                                                    fieldValue,
                                                    {
                                                      rules: [
                                                        {
                                                        }
                                                      ]
                                                    }
                                                  ]"/>
            <a-checkbox
                    style="margin-left: 4px"
                    v-model="fieldValueCheck"
            ></a-checkbox>
        </div>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import moment from "moment";
    export default{
        props:['fieldType','propsValue','checkFlag'],
        watch:{
            fieldValue(val) {

                if(val!=null && val.length > 0) {
                    this.fieldValueCheck = true;
                } else {
                    this.fieldValueCheck = false;
                }

                this.$emit('ref1FieldValueChange',val,this.fieldValueCheck);
                this.$emit('ref2FieldValueChange',val,this.fieldValueCheck);
                this.$emit('ref3FieldValueChange',val,this.fieldValueCheck);
                this.$emit('ref4FieldValueChange',val,this.fieldValueCheck);
                this.$emit('ref5FieldValueChange',val,this.fieldValueCheck);
            },
            fieldValueCheck(val) {
                this.$emit('ref1FieldValueChange',this.fieldValue,val);
                this.$emit('ref2FieldValueChange',this.fieldValue,val);
                this.$emit('ref3FieldValueChange',this.fieldValue,val);
                this.$emit('ref4FieldValueChange',this.fieldValue,val);
                this.$emit('ref5FieldValueChange',this.fieldValue,val);
            }
        },

        data(){
            return{
                fieldValue:this.propsValue,
                selectData: [],
                fieldValueCheck:this.checkFlag,
            }
        },
        methods:{
            deleteUpload() {
                this.defaultImg = "";
            },
            moment,
            dateTimeChange(val) {
                let v = ''
                if(this.fieldType== "Datetime"){
                    v = val!=null?moment(val).format('YYYY-MM-DD HH:mm:ss'):null;
                }
                if (this.fieldType == "Date") {
                    v=  val!=null?moment(val).format('YYYY-MM-DD'):null;
                }
                this.fieldValue = v;
            }
        }
    }
</script>